import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'defaultImage' })
export class DefaultImagePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value || value.trim() === '') {
      return 'assets/images/default-product.png';
    }
    return value;
  }
}
